import { CurrencyPipe } from '@angular/common';
import { Currency } from '../wallet/currency';

export interface WagerTier {
  tierId: string;
  currency: string;
  entryFee: number;
  reward: number;
}

export function amountForCurrency(
  currency: Currency,
  amount: number,
  currencyPipe: CurrencyPipe,
): string {
  // Helper function to determine if the number has a fractional part
  const isWholeNumber = (value: number): boolean => Math.floor(value) === value;

  if (currency === Currency.SAT) {
    return amount.toString();
  } else if (currency === Currency.MCN) {
    return `${amount.toString()}`;
  }

  // For USD or other currencies, adjust the format based on the fraction
  const format = isWholeNumber(amount / 100) ? '1.0-0' : '1.2-2';
  return currencyPipe.transform(amount / 100, 'USD', 'symbol', format) ?? '-';
}
